export default __webpack_public_path__ + "static/media/2106_00 drawing.d3fe882a.gif";